module.exports = __webpack_public_path__ + "static/media/c2bannerModul1_small.342bb961.jpg";